<div class="mb-16 mt-3 flex items-center lg:mb-5" *ngIf="ticketResponse; else loading">
    <form ngNoForm method="post" action="{{ ticketResponse.url }}">
        <input type="hidden" name="ticket" value="{{ ticketResponse.ticketId }}" />
        <button class="btn-secondary mr-16 w-32 lg:w-64" tabindex="0" type="submit">
            {{ 'BTN_LOG_IN' | translate }}
        </button>
    </form>
</div>
<p class="text-center md:text-left">
    {{ 'REGISTER_DONT_HAVE_ACCOUNT' | translate }}
    <a class="link" [routerLink]="'/register' | localize">
        {{ 'LOG_INTO_CREATE_AN_ACCOUNT_LINK' | translate }}
    </a>
</p>
<ng-template #loading>
    <div class="my-4 flex justify-center" *ngIf="!ticketError">
        <mat-spinner [diameter]="50"></mat-spinner>
    </div>
</ng-template>
